var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Router } from '@angular/router';
import { Validation } from '../../shared/app/services/validation';
import { Payee, PayeeServiceDPE, SubmissionTag, SubmissionSubtagMapping } from '../../shared/sdk/models';
import { PayeeApi, StorageApi } from '../../shared/sdk/services';
import { SubmissionDetailService } from "../../shared/app/services/";
import { FormPage } from '../../shared/app/classes/form-page';
import { GlobalEventsManager } from '../../events-manager.component';
import { CONSTANT } from '../../shared/app/constants';
var ɵ0 = window;
var PaymentNotificationTechnicalRequirementComponent = /** @class */ (function (_super) {
    __extends(PaymentNotificationTechnicalRequirementComponent, _super);
    function PaymentNotificationTechnicalRequirementComponent(document, userApi, storageApi, router, eventsManager, submissionDetailService, validation) {
        var _this = _super.call(this, new PayeeServiceDPE(), userApi, storageApi, eventsManager) || this;
        _this.document = document;
        _this.router = router;
        _this.submissionDetailService = submissionDetailService;
        _this.validation = validation;
        _this.TAG = "PaymentNotificationTechnicalRequirementComponent";
        _this.CONSTANT = CONSTANT;
        _this.uatSSL = null;
        _this.prodSSL = null;
        _this.techSpecDisabled = false;
        // Reload script.js
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'js/script.js';
        script.onload = function () {
            console.log('SCRIPT LOAD');
        };
        script.onerror = function () { return console.log('SCRIPT ERROR'); };
        document.getElementsByTagName('head')[0].appendChild(script);
        return _this;
    }
    // Initialisation
    PaymentNotificationTechnicalRequirementComponent.prototype.ngOnInit = function () {
        this.scrollToTop();
        this.setUpFileUploader('');
        this.populateFormData();
    };
    PaymentNotificationTechnicalRequirementComponent.prototype.populateFormData = function () {
        var _this = this;
        console.log("this.submissionDetailService.getCurrentSubmissionId()");
        console.log(this.submissionDetailService.getCurrentSubmissionId());
        this.userApi.findById(this.id, {
            include: [
                {
                    relation: 'services',
                    scope: {
                        where: {
                            'service_id': CONSTANT.SERVICE.ONLINE_BANKING
                        },
                        include: [
                            {
                                relation: 'submission',
                                scope: {
                                    where: {
                                        'id': this.submissionDetailService.getCurrentSubmissionId()
                                    },
                                    include: [
                                        'submission_subtags',
                                        'submission_tags'
                                    ]
                                }
                            }
                        ]
                    }
                },
                {
                    relation: 'm2uPay', scope: {
                        fields: {
                            response_url_uat: true,
                            port_uat: true,
                            response_url_production: true,
                            port_production: true,
                            developer_type: true,
                            developer_name: true,
                            developer_email: true,
                            developer_contact_no: true
                        }
                    }
                }
            ]
        }).subscribe(function (res) {
            console.log("PaymentNotificationTechnicalRequirementComponent getm2upay res");
            console.log(res);
            if (res.hasOwnProperty('m2uPay')) {
                _this.details = res.m2uPay;
            }
            _this.submissionDetailService.setCurrentSubmissionId(res.services[0].submission.id);
            // console.log(res.services[0])
            _this.submission_tags = res.services[0].submission.submission_tags;
            _this.submission_subtags = res.services[0].submission.submission_subtags;
            if (_this.submission_tags) {
                _this.submissionDetailService.setTagMapping(_this.submissionDetailService.getCurrentSubmissionId(), _this.submission_tags);
            }
            if (_this.submission_subtags) {
                _this.submissionDetailService.setSubTagMapping(_this.submissionDetailService.getCurrentSubmissionId(), _this.submission_subtags);
            }
            if (_this.submissionDetailService.subtagExists(_this.submissionDetailService.getCurrentSubmissionId(), CONSTANT.SUBTAG.TECH_SPEC_SUBMITTED)) {
                _this.techSpecDisabled = true;
            }
            _this.eventsManager.loaded(true);
            _this.getFileDetails('uat_ssl').subscribe(function (res) {
                if (res.length > 0) {
                    _this.updateDocStatus('uat_ssl', res[0].file_name);
                }
                else {
                    _this.uatSSL = null;
                }
            });
            _this.getFileDetails('prod_ssl').subscribe(function (res) {
                if (res.length > 0) {
                    _this.updateDocStatus('prod_ssl', res[0].file_name);
                }
                else {
                    _this.prodSSL = null;
                }
            });
        }, function (err) {
            console.log(err);
            _this.eventsManager.loaded(true);
            _this.prodSSL = null;
            _this.uatSSL = null;
        });
    };
    PaymentNotificationTechnicalRequirementComponent.prototype.addEventListeners = function () { };
    // Validation
    PaymentNotificationTechnicalRequirementComponent.prototype.validate = function () {
        this.valid = true;
        this.docsValid = true;
        this.submit.nativeElement.click();
        if (!(this.details.response_url_uat && this.details.port_uat &&
            this.details.response_url_production && this.details.port_production &&
            this.details.developer_type && this.details.developer_name && this.details.developer_contact_no && this.details.developer_email)) {
            this.valid = false;
        }
        else {
            this.valid = this.validation.port(this.details.port_uat) && this.validation.port(this.details.port_production)
                && this.validation.email(this.details.developer_email) && this.valid;
        }
        this.valid = this.validateDocs() && this.valid;
        return this.valid;
    };
    // File manipulation methods
    PaymentNotificationTechnicalRequirementComponent.prototype.updateDocStatus = function (name, fileName) {
        switch (name) {
            case 'uat_ssl':
                this.uatSSL = fileName;
                break;
            case 'prod_ssl':
                this.prodSSL = fileName;
        }
    };
    PaymentNotificationTechnicalRequirementComponent.prototype.addDoc = function (name, event) {
        _super.prototype.addDoc.call(this, name, event, true);
    };
    PaymentNotificationTechnicalRequirementComponent.prototype.validateDocs = function () {
        this.docsValid = this.uatSSL && this.prodSSL;
        return this.docsValid;
    };
    // Save form page
    PaymentNotificationTechnicalRequirementComponent.prototype.save = function (submit) {
        if (!this.uatSSL) {
            this.deleteDoc('uat_ssl');
        }
        if (!this.prodSSL) {
            this.deleteDoc('prod_ssl');
        }
        var promises = [];
        promises.push(this.saveTechDetails());
        var that = this;
        Promise.all(promises)
            .then(function (res) {
            that.saved = true;
            if (!submit) {
                that.eventsManager.savedPopUp();
            }
        }, function (err) {
            that.saved = false;
            if (!submit) {
                that.eventsManager.savedPopUp();
                that.eventsManager.failedSavePopUp();
            }
        });
        return promises;
    };
    PaymentNotificationTechnicalRequirementComponent.prototype.submitOnlineBankingTechReq = function (submit) {
        // if (!this.uatSSL) {
        //   this.deleteDoc('uat_ssl');
        // }
        // if (!this.prodSSL) {
        //   this.deleteDoc('prod_ssl');
        // }
        var _this = this;
        if (this.validate()) {
            var promises = [];
            promises.push(this.saveTechDetails());
            var that = this;
            Promise.all(promises)
                .then(function (res) {
                _this.eventsManager.showPopUp("Payment Notification Technical Requirement has been submitted.");
                _this.router.navigate(['/dashboard']);
            }, function (err) {
                _this.eventsManager.showPopUp("Unable to submit. Please try again later");
            });
            return promises;
        }
        else {
            this.eventsManager.showPopUp("Please check on any field error in the form.");
        }
    };
    PaymentNotificationTechnicalRequirementComponent.prototype.saveTechDetails = function () {
        var that = this;
        return new Promise(function (resolve, reject) {
            that.details.tech_spec_is_submitted = true;
            that.userApi.getM2uPay(that.id).subscribe(function (getM2uPayes) {
                that.userApi.updateM2uPay(that.id, that.details).subscribe(function (updateM2uPayres) {
                    resolve(updateM2uPayres);
                }, function (updateM2uPayerr) {
                    reject(updateM2uPayerr);
                });
            }, function (getM2uPayerr) {
                // console.log("getM2uPayerr")
                // console.log(getM2uPayerr)
                // console.log("that.id")
                // console.log(that.id)
                // console.log("that.details")
                // console.log(that.details)
                // console.log(that.details)
                that.userApi.createM2uPay(that.id, that.details).subscribe(function (createM2uPayres) {
                    console.log("createM2uPayres");
                    console.log(createM2uPayres);
                    resolve(createM2uPayres);
                }, function (createM2uPayerr) {
                    reject(createM2uPayerr);
                });
            });
        });
    };
    PaymentNotificationTechnicalRequirementComponent.prototype.notSaved = function () {
        this.saved = false;
    };
    // Scrolling
    PaymentNotificationTechnicalRequirementComponent.prototype.scrollToTop = function () {
        window.scroll(0, 0);
        this.document.getElementsByClassName('scroll_m2uPay')[0].scrollTop = 0;
    };
    PaymentNotificationTechnicalRequirementComponent.prototype.scrollToSave = function () {
        document.getElementsByClassName('scroll_m2uPay')[0].scrollTop = document.getElementById('save_m2uPay').offsetTop;
    };
    // Before submit, clean up backend data
    PaymentNotificationTechnicalRequirementComponent.prototype.cleanUpData = function () {
        return [];
    };
    return PaymentNotificationTechnicalRequirementComponent;
}(FormPage));
export { PaymentNotificationTechnicalRequirementComponent };
export { ɵ0 };
